export default {"src":"/_next/static/media/longArrayRight.96029177.svg","height":8,"width":16,"blurWidth":0,"blurHeight":0};